import { formatInTimeZone } from 'date-fns-tz'
import { format } from 'date-fns'

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export function formatDateWithTimezonOffset (date) {
  if (!date) {
    return null
  }
  return new Date(date.valueOf() + date.getTimezoneOffset() * 60 * 1000)
}

export const formatUTC = (timestamp) => formatInTimeZone(timestamp, 'UTC', 'MMM d, yyyy')

/**
 * Format a date/timestamp in UTC using a date-fns format string.
 * @param {Date|number|string} date
 * @param {string} dateFormat
 * @returns {string}
 */
export const formatInUTC = (date, dateFormat) => {
  if (!date) {
    return ''
  }

  try {
    const parsed = date instanceof Date ? date : new Date(date)
    if (Number.isNaN(parsed.getTime())) {
      return ''
    }
    return formatInTimeZone(parsed, 'UTC', dateFormat)
  } catch (error) {
    return 'Invalid date'
  }
}

export const formatWrapped = (date, dateFormat) => {
  if (!date) {
    return ''
  }

  try {
    return format(date, dateFormat)
  } catch (error) {
    return 'Invalid date'
  }
}

export const isExpired = (date) => {
  const currentDate = new Date().getTime()

  const comparedDate = new Date(date).getTime()

  return currentDate > comparedDate
}
